import { render, staticRenderFns } from "./GalleryLightbox.vue?vue&type=template&id=dbb893d8"
import script from "./GalleryLightbox.vue?vue&type=script&lang=js"
export * from "./GalleryLightbox.vue?vue&type=script&lang=js"
import style0 from "./GalleryLightbox.vue?vue&type=style&index=0&id=dbb893d8&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/maq/Code/skyier/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dbb893d8')) {
      api.createRecord('dbb893d8', component.options)
    } else {
      api.reload('dbb893d8', component.options)
    }
    module.hot.accept("./GalleryLightbox.vue?vue&type=template&id=dbb893d8", function () {
      api.rerender('dbb893d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/shortcodes/GalleryLightbox.vue"
export default component.exports